// frontend/src/index.js
import React from 'react';
import { hydrate, render } from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './contexts/AuthContext';
import './i18n';
import { PostHogProvider } from 'posthog-js/react';
import { initGA } from './ga';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Configuration options for PostHog
const posthogOptions = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
};

// MainApp Component
const MainApp = () => {
  React.useEffect(() => {
    initGA();
  }, []);

  return (
    <HelmetProvider>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <AuthProvider>
          <PostHogProvider 
            apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
            options={posthogOptions}
          >
            <Router>
              <App />
            </Router>
          </PostHogProvider>
        </AuthProvider>
      </GoogleOAuthProvider>
    </HelmetProvider>
  );
};

// Select the root DOM element
const rootElement = document.getElementById('root');

// Choose between hydrate and render for compatibility with react-snap
const renderMethod = rootElement.hasChildNodes() ? hydrate : render;

// Render the application
renderMethod(
  <React.StrictMode>
    <MainApp />
  </React.StrictMode>,
  rootElement
);

// Optional: Measure performance
reportWebVitals();
